import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScrollToService } from 'ng2-scroll-to-el';
import { SugarService } from '../model/sugar.service';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
})
export class PaginatorComponent implements OnInit, OnDestroy {

  public allPages = 0;
  public currentPage = 1;
  public prevPage = 0;
  public pages = [];
  public list = [];

  public maxPage: number;
  @Output()
  pageChange: EventEmitter<{ [key: string]: number }>;
  @Output()
  pageChanged: EventEmitter<{ [key: string]: number }>;
  @Input()
  collection: string;
  private sugarSub: Subscription;
  private changed: boolean;

  constructor(
    private sugarService: SugarService,
    private scrollService: ScrollToService,
  ) {
    this.pageChange = new EventEmitter();
    this.pageChanged = new EventEmitter();

    this.changed = false;
    this.maxPage = 0;
  }

  ngOnInit(): void {
    this.sugarSub = this.sugarService.getData().subscribe(data => {
      if (data.collectionId === this.collection) {
        this.handleCollection(data);
      }
    });

    this.handleCollection(this.sugarService.getCollectionContents(this.collection));
  }

  ngOnDestroy(): void {
    if (this.sugarSub) {
      this.sugarSub.unsubscribe();
    }
  }

  changePage(page: number | string): void {
    if (page === '...') {
      return;
    }

    if (page > 0 && page <= this.allPages && page !== this.currentPage) {
      this.prevPage = this.currentPage;

      this.changed = true;

      page = typeof page === 'string' ? parseInt(page, 10) : page;

      this.sugarService.changePage(this.collection, page);

      this.pageChange.emit({
        previous: this.prevPage,
        current: page,
      });

      this.scrollService.scrollTo('#top', 600);
    }
  }

  protected build(): void {
    let pagination = [];

    const len = (this.pages || []).length;
    const currentPage = this.currentPage;

    const first = currentPage === 1 ? false : 1;
    const last = currentPage === len ? false : len;

    let before: false | (number | string)[];
    let after: false | (number | string)[];

    if (currentPage <= 2) {
      before = false;
    } else if (currentPage === 3) {
      before = [2];
    } else {
      before = currentPage === 4 ? [2, 3] : ['...', (currentPage - 1)];
    }

    if (currentPage >= (len - 1)) {
      after = false;
    } else if ((currentPage + 1) === (len - 1)) {
      after = [(currentPage + 1)];
    } else {
      after = (currentPage + 2) === (len - 1) ? [(currentPage + 1), (currentPage + 2)] : [(currentPage + 1), '...'];
    }

    if (first) {
      pagination.push(first);
    }

    if (before) {
      pagination = pagination.concat(before);
    }

    pagination.push(currentPage);

    if (after) {
      pagination = pagination.concat(after);
    }

    if (last) {
      pagination.push(last);
    }

    this.maxPage = len;

    this.list = pagination;
  }

  protected handleCollection(data): void {
    if (!data) {
      return;
    }

    this.allPages = data.pagination.all;

    this.pages = [];

    this.currentPage = parseInt(data.pagination.current, 10);
    this.pages = data.pagination.pages;

    if (this.changed) {
      this.pageChange.emit({
        previous: this.prevPage,
        current: this.currentPage,
      });
    }

    this.build();
  }

}
